export default __webpack_public_path__ + "static/media/Bloodseer's Robe.fcf82c5a.jpg";